import {
  CrudBuilderState,
  didError,
  didSucceed,
  getFetchAllSlice,
  getFetchSlice,
  hasFinished,
  hasStarted
} from "seneca-common/utils/apiStates";

type State = CrudBuilderState;

// fetch all
function getFetchAllState(state: State) {
  return getFetchAllSlice(state);
}

export function allStudentAssignmentsAreFetching(state: State): boolean {
  return hasStarted(getFetchAllState(state));
}

export function allStudentAssignmentsFetchSucceeded(state: State): boolean {
  return didSucceed(getFetchAllState(state));
}

export function allStudentAssignmentsFetchCreateErrored(state: State): boolean {
  return didError(getFetchAllState(state));
}

export function allStudentAssignmentsFetchFinished(state: State) {
  return (
    allStudentAssignmentsFetchSucceeded(state) ||
    allStudentAssignmentsFetchCreateErrored(state)
  );
}

export function allStudentAssignmentsNeedFetching(state: State) {
  return !(
    allStudentAssignmentsFetchSucceeded(state) ||
    allStudentAssignmentsAreFetching(state)
  );
}

// fetch one

function getFetchSliceState(state: State) {
  return getFetchSlice(state);
}

export function singleAssignmentIsFetching(
  state: State,
  assignmentId: string
): boolean {
  return hasStarted(getFetchSliceState(state), assignmentId);
}

export function singleAssignmentFetchSucceeded(
  state: State,
  assignmentId: string
): boolean {
  return didSucceed(getFetchSliceState(state), assignmentId);
}

export function singleAssignmentFetchErrored(
  state: State,
  assignmentId: string
): boolean {
  return didError(getFetchSliceState(state), assignmentId);
}

export function singleAssignmentFetchFinished(
  state: State,
  assignmentId: string
): boolean {
  return hasFinished(getFetchSliceState(state), assignmentId);
}

export function singleAssignmentNeedsFetching(
  state: State,
  assignmentId: string
) {
  return !(
    singleAssignmentFetchSucceeded(state, assignmentId) ||
    singleAssignmentIsFetching(state, assignmentId)
  );
}

// multiple

export function childAssignmentsAreFetching(
  state: State,
  userId: string
): boolean {
  return hasStarted(getFetchSliceState(state), userId);
}

export function childAssignmentsFetchSucceeded(
  state: State,
  userId: string
): boolean {
  return didSucceed(getFetchSliceState(state), userId);
}

export function childAssignmentsFetchCreateErrored(
  state: State,
  userId: string
): boolean {
  return didError(getFetchSliceState(state), userId);
}

export function childAssignmentsFetchFinished(state: State, userId: string) {
  return (
    childAssignmentsFetchSucceeded(state, userId) ||
    childAssignmentsFetchCreateErrored(state, userId)
  );
}

export function childAssignmentsNeedFetching(state: State, userId: string) {
  return !(
    childAssignmentsFetchSucceeded(state, userId) ||
    childAssignmentsAreFetching(state, userId)
  );
}
